// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { cn } from '@/lib/utils';

export interface CardGridProps {
  columns?: 2 | 3 | 4;
  children: React.ReactNode;
  className?: string;
}

const COLUMN_CLASSES: Record<2 | 3 | 4, string> = {
  2: 'grid gap-3 sm:grid-cols-2',
  3: 'grid gap-3 sm:grid-cols-2 md:grid-cols-3',
  4: 'grid gap-3 sm:grid-cols-2 md:grid-cols-4',
};

export function CardGrid({ columns = 2, children, className }: CardGridProps) {
  return <div className={cn(COLUMN_CLASSES[columns], className)}>{children}</div>;
}
